






























































































































































































import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { appModule } from "@/store/modules/app";
import { userModule } from "@/store/modules/user";
import SkriningBunuhDiriService from "@/services/SkriningBunuhDiri";
import TimeStamp from "@/components/pemeriksaan/assesmen/TimeStamp.vue";
import moment from "moment";
import {
  SBD_ALASAN_PENGKAJIAN,
  SBD_INSTRUMEN,
  SBD_ITEMS,
  SBD_KATEGORI,
  SBD_PERILAKU_NONVERBAL,
  SBD_TANDA_RISIKO_AKUT,
  SbdItem,
  SbdItemCode,
  SbdKategori,
  SbdLevel
} from "@/constants/skriningBunuhDiri";

function freshAnswers(): Record<SbdItemCode, string> {
  return { SBD_Q1: "", SBD_Q2: "", SBD_Q3: "", SBD_Q4: "", SBD_Q5: "", SBD_QT: "" };
}

@Component({
  inject: {
    isReadOnly: { default: () => () => false }
  },
  components: { TimeStamp }
})
export default class CardSkriningBunuhDiri extends Vue {
  @Prop() register!: string;
  @Prop() rm!: string;
  @Prop() value!: any;
  @Prop({ default: "ralan" }) encounterType!: string;

  isReadOnly!: () => boolean;

  get readOnly(): boolean {
    return this.isReadOnly();
  }

  valid = true;
  saving = false;

  items = SBD_ITEMS;
  alasanOptions = SBD_ALASAN_PENGKAJIAN;
  tandaAkutOptions = SBD_TANDA_RISIKO_AKUT;
  perilakuOptions = SBD_PERILAKU_NONVERBAL;

  id: number = null;
  alasanPengkajian: string = null;
  alasanPengkajianLainnya = "";
  adaPendamping: boolean = null;
  answers: Record<SbdItemCode, string> = freshAnswers();
  tandaRisikoAkut: string[] = [];
  perilakuNonverbal: string[] = [];
  ringkasanKlinis = "";
  examinedAt = moment().format("YYYY-MM-DD HH:mm:ss");

  get maxDate() {
    return moment().format("YYYY-MM-DD");
  }

  get skriningAwalPositif(): boolean {
    return this.items.some(i => i.skriningAwal && this.answers[i.code] === "yes");
  }

  isRequired(item: SbdItem): boolean {
    return item.skriningAwal || this.skriningAwalPositif;
  }

  answerRules(item: SbdItem) {
    return this.isRequired(item) ? [(v: string) => !!v || "Wajib dijawab"] : [];
  }

  get derivedLevel(): SbdLevel | null {
    if (this.answers.SBD_Q5 === "yes" || this.tandaRisikoAkut.length > 0) {
      return "tinggi";
    }
    const lengkap = this.items.filter(i => this.isRequired(i)).every(i => !!this.answers[i.code]);
    if (!lengkap) {
      return null;
    }
    if (this.skriningAwalPositif || this.answers.SBD_QT === "yes" || this.perilakuNonverbal.length > 0) {
      return "sedang";
    }
    return "none";
  }

  get kategori(): SbdKategori | null {
    return this.derivedLevel ? SBD_KATEGORI[this.derivedLevel] : null;
  }

  @Watch("value")
  onValueChange(val) {
    if (val) this.populateForm(val);
  }

  populateForm(item) {
    this.id = item.id;
    this.alasanPengkajian = item.alasan_pengkajian || null;
    this.alasanPengkajianLainnya = item.alasan_pengkajian_lainnya || "";
    this.adaPendamping = typeof item.ada_pendamping === "boolean" ? item.ada_pendamping : null;
    const answers = freshAnswers();
    (item.items || []).forEach(it => {
      const code = it.instrumen_item_code as SbdItemCode;
      if (code in answers) {
        answers[code] = it.jawaban;
      }
    });
    this.answers = answers;
    this.tandaRisikoAkut = [...(item.tanda_risiko_akut || [])];
    this.perilakuNonverbal = [...(item.perilaku_non_verbal || [])];
    this.ringkasanKlinis = item.ringkasan_klinis || "";
    this.examinedAt = item.tanggal_skrining
      ? `${item.tanggal_skrining} ${item.jam_skrining || "00:00"}:00`
      : moment().format("YYYY-MM-DD HH:mm:ss");
  }

  setTime(val) {
    this.examinedAt = val;
  }

  get sendData() {
    const items = this.items
      .filter(i => !!this.answers[i.code])
      .map(i => ({
        instrumen_item_code: i.code,
        jawaban: this.answers[i.code]
      }));
    return {
      register_id: this.register,
      pasien_rm: this.rm,
      unit_id: userModule.user ? userModule.user.unit_id : null,
      encounter_type: this.encounterType,
      instrumen: SBD_INSTRUMEN,
      tanggal_skrining: moment(this.examinedAt).format("YYYY-MM-DD"),
      jam_skrining: moment(this.examinedAt).format("HH:mm:ss"),
      alasan_pengkajian: this.alasanPengkajian,
      alasan_pengkajian_lainnya:
        this.alasanPengkajian === "lainnya" ? this.alasanPengkajianLainnya.trim() : null,
      ada_pendamping: this.adaPendamping,
      tanda_risiko_akut: this.tandaRisikoAkut,
      perilaku_non_verbal: this.perilakuNonverbal,
      ringkasan_klinis: this.ringkasanKlinis || null,
      items: items
    };
  }

  save() {
    if (this.readOnly) return;
    if (!(this.$refs.form as any).validate()) {
      appModule.NoticeDelay("Lengkapi isian skrining yang wajib terlebih dahulu");
      return;
    }

    this.saving = true;
    const action = this.id
      ? SkriningBunuhDiriService.update(this.id, this.sendData)
      : SkriningBunuhDiriService.create(this.sendData);

    action
      .then(resp => {
        if (resp && resp.data) {
          appModule.NoticeDelay(
            this.id ? "Skrining berhasil diubah" : "Skrining berhasil disimpan"
          );
          this.resetForm();
          this.$emit("saved", resp.data);
        }
      })
      .finally(() => {
        this.saving = false;
      });
  }

  resetForm() {
    this.id = null;
    this.alasanPengkajian = null;
    this.alasanPengkajianLainnya = "";
    this.adaPendamping = null;
    this.answers = freshAnswers();
    this.tandaRisikoAkut = [];
    this.perilakuNonverbal = [];
    this.ringkasanKlinis = "";
    this.examinedAt = moment().format("YYYY-MM-DD HH:mm:ss");
    this.$emit("input", null);
    if (this.$refs.form) (this.$refs.form as any).resetValidation();
  }
}
